import { render, staticRenderFns } from "./PagePricing.vue?vue&type=template&id=294f6b87&"
import script from "./PagePricing.vue?vue&type=script&lang=ts&"
export * from "./PagePricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports